"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _TranslationKey = require("./TranslationKey");
Object.keys(_TranslationKey).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _TranslationKey[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _TranslationKey[key];
        }
    });
});
